export const currencyFormatter = (code, price) => {
  const formatter = new Intl.NumberFormat('en-UK', {
    style: 'currency',
    currency: code || 'GBP',
    minimumFractionDigits: 2
  })
  return formatter.format(price)
}
